export enum ModalSize {
	Default = 'default',
	Medium = 'medium',
	Large = 'large',
	Full = 'full',
}
